<template>
<e-chart ref="chart" />
</template>

<script>

export default {
  name: 'AuditOverviewChart',
  props: {
    data: {
      required: true,
      type: Object
    },
    day: {
      required: true,
      type: Date
    },
    clientHeight: {
      required: true
    }
  },
  watch: {
    data: {
      immediate: true,
      handler (newVal) {
        let data = newVal[new Date(this.day).format('YYYY-MM-DD')]
        if (data) {
          this.render()
        }
      }
    }
  },
  methods: {
    render (isReal) {
      let data = this.data[new Date(this.day).format('YYYY-MM-DD')]
      if (!data) {
        return
      }
      let series = []
      series.push({
        name: '未审核',
        value: data.noAuditNum
      })
      series.push({
        name: '已审核',
        value: data.overAuditNum
      })
      let chartOpt = {
        grid: {
          top: 0,
          left: 0,
          right: 0,
          bottom: 0
        },
        series: [{
          type: 'pie',
          color: ['#909399', '#67c23a'],
          top: 0,
          left: 0,
          center: ['50%', '50%'],
          radius: '100%',
          label: {
            formatter: function (params) {
              return params.value === 0 ? '' : params.value
            },
            position: 'inside',
            fontSize: this.clientHeight > 550 ? 14 : 8,
            color: '#FFFFFF'
          },
          emphasis: {
            scale: false
          },
          data: series
        }]
      }

      this.$refs.chart.setOpt(chartOpt)
      this.$refs.chart.resize()
    }
  },
  created () {
    window.addEventListener('resize', this.render)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.render)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Data/AuditOverviewChart.vue